<template>
  <div>
    <v-autocomplete :items="items" :input-attrs="input" v-model="item" :get-label="getLabel" :component-item='template' @update-items='updateItems' @item-selected="itemSelected"></v-autocomplete>
    <input type="hidden" :name="input.name" />
  </div>
</template>

<style type="text/css">
  .v-autocomplete {
    position: relative;
    z-index: 1;
  }
  .v-autocomplete .v-autocomplete-input {
    width: 100%;
    border: none;
  }
  .v-autocomplete .v-autocomplete-list {
    border: 1px solid #ccc;
    background-color: #fff;
    width: 80%;
    max-height: 300px;
    overflow-y: auto;
    padding: 10px;
    position: absolute;
  }
</style>

<script>
import VAutocomplete from 'v-autocomplete'
import inputCityItem from './inputCityItem.vue'
export default {
  name: 'inputCity',
  props: ['value','name','required'],
  data () {
    return {
      input: {
        value: this.value,
        name: this.name,
        required: this.required,
        title: 'Veuillez saisir le nom de la ville, et la sélectionner',
        pattern: '^[A-ZÀÁÂÃÄÅÒÓÔÕÖØÈÉÊËÇÌÍÎÏÙÚÛÜÑ].*'
      },
      item: {id:0,name:''},
      items: [],
      template: inputCityItem
    }
  },
  methods: {
    getLabel(item) {
        if( item != null && item.name !== ""){
            return item.name;
        }
    },
    updateItems(text) {
      var self=this;
      axios.get('/cities/get/'+text).then(function (response) {
        self.items=response.data;
      });
    },
    itemSelected(item) {
        if( item.id !== 0){
            document.querySelector('input[type="hidden"][name="city_id"]').value=item.id;
        }
    }
  },
  mounted() {
      if(this.input.value !== 0 && this.input.value != ''){
        document.querySelector('input[type="hidden"][name="city_id"]').value=this.input.value;
        var self=this;
        axios.get('/cities/get/'+this.input.value).then(function (response) {
          self.item=response.data;
        });
      }
  },
  components: {
    VAutocomplete,
    inputCityItem
  }
}
</script>